import { TableCell, TableRow } from '@mui/material';
import MyShowMoreText from 'components/common/MyShowMoreText';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment-timezone';
import { bool, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const EmployeeRow = ({ employee, showName }) => {
  const getName = e => e.name + (isEmpty(e.code) ? '' : ` - ${e.code}`);

  const ResponseContent = () => {
    if (isArray(employee.response)) {
      return employee.response.map(({ label }) => label).join(', ');
    }
    if (typeof employee.response === 'string') {
      return <MyShowMoreText lines={2}>{employee.response}</MyShowMoreText>;
    }
    return employee.response || '';
  };

  return (
    <TableRow
      sx={theme => ({
        border: 0,
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.secondary.ultraUltraLight,
        },
      })}
      key={employee._id}
    >
      {showName && (
        <TableCell sx={{ minWidth: 110, maxWidth: 400 }} padding="normal">
          {getName(employee)}
        </TableCell>
      )}
      <TableCell sx={{ minWidth: 110, maxWidth: 400 }} padding="normal">
        {moment(employee.respondedAt).calendar(null, {
          sameDay: `[${I18n.t('FormAnalyticsDrawer.Today')} ${I18n.t(
            'FormAnalyticsDrawer.at',
          )}] LT`,
          lastDay: `[${I18n.t('FormAnalyticsDrawer.Yesterday')} ${I18n.t(
            'FormAnalyticsDrawer.at',
          )}] LT`,
          lastWeek: `dddd [${I18n.t('FormAnalyticsDrawer.at')}] LT`,
          sameElse: 'LL',
        })}
      </TableCell>
      <TableCell sx={{ minWidth: 110, maxWidth: 400 }} padding="normal">
        <ResponseContent />
      </TableCell>
    </TableRow>
  );
};

EmployeeRow.propTypes = {
  employee: object.isRequired,
  showName: bool.isRequired,
};

export default EmployeeRow;
